<!--
 * @Description: Header用户栏下方-绑定微信浮层
 * @LastEditors: YGQ
 * @LastEditTime: 2026-09-23 14:40:00
-->
<template>
  <!-- 浮层渲染在父级相对定位容器内, 锚定在用户栏下方 -->
  <div v-if="visible" class="wechat-popover">
    <div class="popover-card">
      <!-- 微信扫码绑定二维码 -->
      <LoginWeChat
        platform="wechat"
        text1="关注服务号"
        text2="接收重要通知推送"
        type="popover"
        api="getThirdPartyBindCode"
        @ok="onBindSuccess"
      />
    </div>
  </div>
</template>

<script>
import LoginWeChat from "@/components/LoginWeChat";

export default {
  name: "HeaderWeChatPopover",
  components: { LoginWeChat },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 关闭浮层
     */
    close() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    /**
     * 扫码绑定成功
     */
    onBindSuccess() {
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        user.isSubscribeWx = 1; // 关注公众号即视为已绑定
        localStorage.setItem("user", JSON.stringify(user));
      } catch (err) {
        console.error("更新本地缓存用户信息失败", err);
      }
      this.$msg.success("绑定成功");
      this.close();
    },
  },
};
</script>

<style scoped>
.wechat-popover {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 2000;
}

.popover-card {
  box-sizing: border-box;
  border-radius: 12px;
}
</style>
